import { render, staticRenderFns } from "./rcscolaire.vue?vue&type=template&id=61efea36&scoped=true"
import script from "./rcscolaire.vue?vue&type=script&lang=js"
export * from "./rcscolaire.vue?vue&type=script&lang=js"
import style0 from "./rcscolaire.vue?vue&type=style&index=0&id=61efea36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61efea36",
  null
  
)

export default component.exports